import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthService } from 'app/services/auth.service';
import { ClearLoadingTimeoutAction } from 'app/store/actions/api.action';
import { UserLoginFailureAction } from 'app/store/actions/login.actions';
import { AppState } from 'app/store/states/app.state';
import { Subscription } from 'rxjs';
import { DashNotificationsService } from 'app/services/dash-notifications.service';
import { AirbrakeService } from 'app/services/airbrake.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [ AuthService ]
})

export class LoginComponent implements OnInit, OnDestroy {
  username = '';
  password = '';
  returnUrl: string;
  remember: boolean;
  loggedInSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
    private notifications: DashNotificationsService,
    private airbrakeService: AirbrakeService,
  ) {}

  ngOnInit() {

    this.store.dispatch(new ClearLoadingTimeoutAction());

    this.activatedRoute.queryParams.subscribe(
      (queryParam: any) => this.returnUrl = queryParam['returnUrl']
    );
  }

  ngOnDestroy() {
    if (this.loggedInSubscription) {
      this.loggedInSubscription.unsubscribe();
    }
  }

  onUserLoginSubmit() {
    this.authService
      .login(this.username.toLocaleLowerCase(), this.password, this.remember)
      .subscribe((response: any) => {
        this.goToLoginLandingPage(response);
      },
      (response: any) => {
        this.store.dispatch(new UserLoginFailureAction(response));
        if(response?.houwzer_error_code === 1010) {
          this.router.navigate(['/login','unconfirmed'], { state: { emailAddress: this.username }})
        } else if(response?.houwzer_error_code === 1011) {
          this.router.navigate(['/signup','expired_invitation'])
        } else if(response?.houwzer_error_code === 1024) {
          this.router.navigate(['/login','questionnaire'])
        } else if(response?.houwzer_error_code === 1000) {
          this.notifications.error('Please check your email and password and try again.');
        } else if(response?.message) {
          this.notifications.error(response.message);
        } else {
          this.notifications.error('An unknown error occurred.');
          this.airbrakeService.notify({
            error: 'Unknown login error',
            params: { response: response }
          });
        }
      });
  }

  goToLoginLandingPage(response: any){
    if(this.returnUrl && this.returnUrl.length) {
      this.router.navigate([this.returnUrl]);
      return;
    }

    // if(response.dotloop_state_token && response.dotloop_state_token.length) {
    //   this.router.navigate([ 'dash', 'dotloop-authorization', 'authorize' ], { queryParams: { state: response.dotloop_state_token }});
    //   return;
    // }

    if(response.user.welcomed){
      this.router.navigate([ 'dash' ]);
    } else {
      this.router.navigate([ 'dash', 'welcome' ], { queryParams: { returnUrl: 'dash' }});
    }
  }
}

